import { atom } from "jotai";

export const turnosAtom = atom([]);

export const openModalCrearTurnoAtom = atom(false);

// export const turnoCreadoAtom = atom(null);
// export const openModalEditarProveedorAtom = atom(false);
// export const proveedorIdSelecionadoAtom = atom(undefined);
export const formInstanceAtom = atom(undefined);